<template>
  <footer>Footer - AHHHHHHHHH CADÊ MEU FOOTER?</footer>
</template>
<script>
export default {
  name: "Footer"
};
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue